import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { getMessaging, onMessage, isSupported } from "firebase/messaging";
import {Modal} from "react-bootstrap";
import {Button} from "reactstrap";

class LLPushNotification extends Component {
    constructor(props) {
        super(props);
        this.state ={
            showNotificationBanner: false,
            pushNotificationMsg: '',
            showPushNotification: false,
            actionButton: 'OK',
            actionURL: '',
            title: '',
            redirect: false
        }
        this.handleClosePushNotification = this.handleClosePushNotification.bind(this);
        this.handlePushNotification = this.handlePushNotification.bind(this);
    }
        
    async componentDidMount() {
        console.log("LLPushNotifiction-> componentDidMount-> Before isSupported check");
        const isBrowserFirebaseMessagingSupport = await isSupported();
        console.log("LLPushNotifiction-> componentDidMount-> After isSupported check");

        if (isBrowserFirebaseMessagingSupport === true) {
            console.log('LLPushNotifiction-> Firebase messaging is supported');
            console.log('LLPushNotifiction-> is notification allowed by user: ', Notification.permission);
            this.state.showNotificationBanner = Notification.permission === 'default';
            console.log('LLPushNotifiction-> showNotificationBanner: ', this.state.showNotificationBanner);
            
            const messaging = getMessaging();
            onMessage(messaging, (payload) => {
                this.handlePushNotification(payload);
            });                    
        }
        else
            console.log('LLPushNotifiction-> componentDidMount: Firebase messaging is not supported');            
    }

    handlePushNotification = (payload) => { 
        console.log('LLPushNotifiction-> Received foreground message: ', payload);
        const LLNotification = JSON.parse(payload.data.body);
        this.state.title = LLNotification.title;
        const customAttributes = new Map(Object.entries(LLNotification.customAttributes));
          
        //Handle the message based on message type
        if(LLNotification.messageType === 'VERIFY_REQUEST') {
            this.state.actionURL = LLNotification.clickAction + customAttributes.get("requestId");
            this.state.actionButton = "Verify Now";
        }
        this.state.showPushNotification = true;
        this.state.pushNotificationMsg = LLNotification.message;

        console.log('LLPushNotifiction-> showPushNotification: ', this.state.showPushNotification);
        this.forceUpdate();                              
    };

    handleClosePushNotification = () => { 
        //reset all the state variables and redirect if action url is present
        if(this.state.actionURL !== '')
            this.state.redirect = true;
        this.state.showPushNotification = false;
        this.state.pushNotificationMsg = '';                
        this.state.title = '';
        this.forceUpdate();
    };

    render() {
        if(this.state.redirect){
            const actionUrl = this.state.actionURL;
            this.state.actionURL = '';
            return <Navigate to={actionUrl} />         
        }
        return( 
        <>
            {this.state.showNotificationBanner &&
            this.props.response &&
            this.props.response.login && 
            this.props.response.login.isSuperAdmin ?
            <div align="center" style={{color: 'red', backgroundColor: 'yellow', fontWeight: 'bold'}} className="notification-banner">
                Click Allow in browser prompt for receiving life saving notifications
            </div> : ''} 
            
            <Modal
                centered
                show={this.state.showPushNotification}
                onHide={this.handleClosePushNotification}
                backdrop="static"
                keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.pushNotificationMsg}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn btn-primary mr-2" variant="primary" onClick={this.handleClosePushNotification}>
                        {this.state.actionButton}
                        </Button>
                    </Modal.Footer>
            </Modal>            
        </>
    )}
};
  
const mapStateToProps = (response) => ({response});
export default connect(mapStateToProps)(LLPushNotification);